import angular from 'angular';
import NgUser from 'cars-ng-user';
import MyAlertsService from './vdpMyAlerts/index';
import NgTracking from 'cars-ng-tracking';
import CarsNgBrowser from 'cars-ng-browser';
import ListingService from '../listing/index';
import Config from '../config/index';
import localStorage from 'cars-ng-browser';
import NgOverlays from 'cars-ng-overlays';
import Graphics from '../cuiIcon/lib';

import component from './saveVehicle.component';
import saveVehicleService from './saveVehicle.service';

export default angular.module('cars.enhanced.vdp.vdpSaveVehicle', [
    /* your module dependencies go here */
    Graphics,
    NgOverlays,
    NgUser,
    MyAlertsService,
    NgTracking,
    ListingService,
    Config,
    CarsNgBrowser,
    localStorage
])
.directive('vdpeSaveVehicle', component)
.factory('saveVehicleService', saveVehicleService)
.name;
